import React from 'react'
import axios from 'axios'
import ReCAPTCHA from 'react-google-recaptcha'
import { analytics } from 'firebase'

import store from '../../../../redux'
import classes from './style.module.css'

import config from '../../../../config/environment'
import Status from '../../../Status/Status'
import Wave from '../../../../images/icon/waves.svg'
import Icon from '../../../elements/Icon'
import Arrow from '../../../../images/icon/arrow.svg'
import ArrowBack from '../../../../images/icon/arrowBack.svg'
import Loader from '../../../../images/icon/loader.svg'
import PlayMarket from '../../../../images/icon/playMarket.svg'
import AppStore from '../../../../images/icon/appStore.svg'

import { fetchingAction, screenBackAction } from '../../../../redux/stores/firstScreen/action'
import { strings } from '../../../../i18n'


import CheckData from '../../../MobileExchenger/elements/CheckData/CheckData'
import CurrencyName from '../../../elements/currency'


const { dispatch } = store
const reCaptchaRef = React.createRef()

const formatDate = (date) => {
    let d = new Date(date),
        day = '' + d.getDate(),
        month = '' + (d.getMonth() + 1),
        year = d.getFullYear()
    if (month.length < 2) {
        month = '0' + month
    }
    if (day.length < 2) {
        day = '0' + day
    }

    return [day, month, year].join('.')
}

const screenBack = async (state) => {
    dispatch(screenBackAction(state))
    window.history.back()
}

const getBankFeeString = (state) => {
    const fixedFee = state.feeData.providerFee.in.find(fee => fee.type === 'FIXED')
    const percentFee = state.feeData.providerFee.in.find(fee => fee.type === 'PERCENT')
    return percentFee.amount + '% + ' + fixedFee.amount + ' ' + (state.inCurrency.length > 5 ? state.inCurrency.slice(4, state.inCurrency.length) : state.inCurrency)
}

const getNetworkFeeString = (state) => {
    const fixedFee = state.feeData.providerFee.out.find(fee => fee.type === 'FIXED')
    const percentFee = state.feeData.providerFee.out.find(fee => fee.type === 'PERCENT')
    return percentFee.amount + '% + ' + fixedFee.amount + ' ' + (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency)
}

const getTrusteeFeeString = (state) => {
    switch (state.exchangeWayType) {
        case 'BUY':
            return state.feeData.trusteeFee.in.find(fee => fee.type === 'PERCENT').amount + '%'

        case 'SELL':
            return state.feeData.trusteeFee.out.find(fee => fee.type === 'PERCENT').amount + '%'

        case 'EXCHANGE':
            return ''
        default:
            return ''
    }
}

const getTrusteeFeeAmount = (state) => {
    switch (state.exchangeWayType) {
        case 'BUY':
            return state.equivalentData.equivalentData.trusteeFee.in + ' ' + state.inCurrency

        case 'SELL':
            return state.equivalentData.equivalentData.trusteeFee.out + ' ' + state.outCurrency

        case 'EXCHANGE':
            return ''
        default:
            return ''
    }
}

const fetching = (state) => {
    dispatch(fetchingAction(state))
}

export const createOrderButtonHandler = async (state, captcha = null, self = null) => {
    const captchaToken = !captcha ? await reCaptchaRef.current.executeAsync() : await captcha.current.executeAsync()

    const body = {
        inAmount: state.equivalentData.equivalentData.inAmount,
        outAmount: state.equivalentData.equivalentData.outAmount,
        exchangeWayId: state.equivalentData.exchangeWayId,
        outDestination: state.outDestination,
        outDestinationTag: state.outDestinationTag,
        cashbackToken: state.cashbackToken,
        locale: state.locale,
        email: state.email,
        equivalentData: state.equivalentData.equivalentData,
        captchaToken
    }

    if (state.cardData) {
        body.paymentDetailsData = {
            paymentDetails: state.cardData.number,
        }
        if (state.cardData?.countryCode) {
            body.paymentDetailsData = {
                ...body.paymentDetailsData,
                supportedCountries: [state.cardData.countryCode]
            }
        }

        // if (state.payway === 'ADVCASH') {
        //     body.uniqueParams.email = state.paymentData.cardEmail
        // }
    }

    if (state.externalId) {
        body.invoiceData = {
            externalId: state.externalId
        }
    }

    if (state.callbackUrl) {
        body.invoiceData = {
            ...body.invoiceData,
            callbackUrl: state.callbackUrl
        }
    }

    if (state.redirectUrl) {
        body.invoiceData = {
            ...body.invoiceData,
            redirectUrl: state.redirectUrl
        }
    }

    fetching(state)

    try {
        const response = await axios.post(config.backendUrl + '/order/create-order', body)
            .catch(error => {
                console.log(error.response.data.message)
                throw new Error(error.response.data.message)
            })
        const orderData = response.data

        const android = window.navigator.userAgent.indexOf('Chrome')

        if (state.exchangeWayType === 'BUY') {
            if (android === -1) {
                try {
                    const link = document.getElementById('url_link')
                    link.href = orderData.url
                    link.click()
                } catch (e) {
                    console.log(e)
                    window.open(orderData.url, !self ? '_blank' : '_self')
                }
            } else {
                window.open(orderData.url, !self ? '_blank' : '_self')
            }

        }
        if (!self) {
            window.open('/order-status?orderHash=' + orderData.orderHash, '_self')
        }

    } catch (error) {
        captcha ? captcha.current.reset() : reCaptchaRef.current.reset()
        alert(error.message)
    }
}

const RenderSecondScreen = (props) => {

    const state = store.getState().firstScreen

    if (!state.feeData) {
        console.log('Invalid feeData')
        return null
    }

    if (!state.isFetching) {
        window.scroll(0, 0)
    }
    let date = new Date()

    analytics().logEvent('open_PaymentScreen')
    analytics().setCurrentScreen('PaymentScreen')

    return (
        <>
            {!state.externalId && <Status screen={state.screen} />}
            <div className={classes.second__screen}>
                <div style={{ display: 'none' }}>
                    <a id='url_link' target="_blank" rel='noopener noreferrer' />
                </div>
                <div className={classes.check}>
                    <div className={classes.wave}>
                        <img src={Wave} alt={'wave'} />
                    </div>
                    <h3>{strings('secondScreen.receipt')}</h3>
                    <div className={classes.date}>
                        {formatDate(date)}
                    </div>
                    <div className={classes.currency__get}>
                        <Icon currencyCode={state.outCurrency} name={false} style={{ marginLeft: '32px' }} />
                        <div className={classes.value__get}>
                            {strings('firstScreen.youGet')}
                        </div>
                        <div className={classes.currency__value__get}>
                            {(state.equivalentData.providerName !== '365CASH' ? '~' : '') + state.equivalentData.equivalentData.outAmount + ' ' +
                                (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency)}
                        </div>
                    </div>
                    <div className={classes.data}>
                        <div className={classes.dash}>
                            <div className={classes.circle__arrow}>
                                <img src={Arrow} alt={'arrow'} />
                            </div>
                        </div>
                        <div className={classes.info}>
                            <div style={{ width: 380 }}>
                                <div className={classes.post}>
                                    {strings('secondScreen.rate')}
                                </div>
                                <div className={classes.rate}>
                                    <div className={classes.post__value}>
                                        {(state.equivalentData.providerName !== '365CASH' ? '~' : '') + state.equivalentData.equivalentData.exchangeRate + ' ' +
                                            (state.equivalentData.equivalentData.exchangeRatesCurrencySide === 'IN' ?
                                                state.inCurrency : (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency))}
                                    </div>
                                </div>
                            </div>
                            <div className={classes.post}>
                                {strings('secondScreen.bankFee')} {getBankFeeString(state)}
                            </div>
                            <div className={classes.rate}>
                                <div className={classes.post__value}>
                                    {state.equivalentData.equivalentData.providerFee.in + ' ' +
                                        (state.equivalentData.equivalentData.exchangeRatesCurrencySide === 'IN' ?
                                            state.inCurrency : (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency))}
                                </div>
                            </div>
                            <div className={classes.post}>
                                {strings('secondScreen.networkFee')} {getNetworkFeeString(state)}
                            </div>
                            <div className={classes.rate}>
                                <div className={classes.post__value}>
                                    {state.equivalentData.equivalentData.providerFee.out + ' ' +
                                        (state.equivalentData.equivalentData.exchangeRatesCurrencySide === 'IN' ?
                                            state.inCurrency : (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency))}
                                </div>
                            </div>
                            <div className={classes.post}>
                                {strings('secondScreen.trusteeFee')} {getTrusteeFeeString(state)}
                            </div>
                            <div className={classes.rate}>
                                <div className={classes.post__value}>
                                    {getTrusteeFeeAmount(state)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.currency__give}>
                        <Icon currencyCode={state.inCurrency} name={false} style={{ marginLeft: '32px' }} />
                        <div className={classes.value__give}>
                            {strings('firstScreen.youGive')}
                        </div>
                        <div className={classes.currency__value__give}>
                            {state.equivalentData.equivalentData.inAmount + ' ' + (state.inCurrency.length > 5 ? state.inCurrency.slice(4, state.inCurrency.length) : state.inCurrency)}
                        </div>
                    </div>
                    <div className={classes.attention__wrapper}>
                        <div className={classes.attention}>
                            {strings('secondScreen.attention')}
                        </div>
                    </div>
                    <div className={classes.button__wrapper}
                        style={state.exchangeWayType !== 'BUY' ? { paddingBottom: 60 } : null}>
                        <button className={classes.arrow__back} onClick={() => {
                            screenBack(state)
                            analytics().logEvent('click_back_from_paymentScreen')
                        }}>
                            <img src={ArrowBack} alt={'back'} />
                        </button>
                        <div className={classes.check__button}>
                            <button
                                onClick={async () => {
                                    await createOrderButtonHandler(state)
                                    analytics().logEvent('paywayScreen_click_' + state.exchangeWayType.toString().toLowerCase())
                                }}>
                                {strings('firstScreen.' + state.exchangeWayType.toString().toLowerCase()) || strings('firstScreen.createOrder')}
                            </button>
                        </div>
                        {state.isFetching ?
                            <div className={classes.preloader}>
                                <img src={Loader} alt={'Preloader'} height={50} />
                            </div>
                            : null}
                    </div>
                    {state.exchangeWayType === 'BUY' ?
                        <>
                            <div className={classes.check__dash}></div>
                            <div className={classes.check__circle__left}></div>
                            <div className={classes.check__circle__right}></div>
                            <div className={classes.download__text}>
                                {strings('secondScreen.downloadText')}
                            </div>
                            <div className={classes.button__app}>
                                <a href={'https://play.google.com/store/apps/details?id=com.trusteewallet'}
                                    target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                        analytics().logEvent('click_google_play')
                                    }}>
                                    <button>
                                        <img src={PlayMarket} alt={'PlayMarket'} />
                                    </button>
                                </a>
                                <a href={'https://apps.apple.com/ua/app/trustee-wallet/id1462924276'}
                                    target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                        analytics().logEvent('click_app_store')
                                    }}>
                                    <button>
                                        <img src={AppStore} alt={'AppStore'} />
                                    </button>
                                </a>
                            </div>
                        </> : null}
                </div>
                <div className={classes.mobile__check}>
                    <h3>{strings('firstScreen.exchangeFor').slice(0, strings('firstScreen.exchangeFor').indexOf(' ') + 1)} {<CurrencyName currencyCode={state.inCurrency} />} {strings('firstScreen.exchangeFor').slice(strings('firstScreen.exchangeFor').indexOf(' '), strings('firstScreen.exchangeFor').length)} {
                        <CurrencyName currencyCode={state.outCurrency} />}</h3>
                    <div className={classes.date}>
                        {formatDate(date)}
                    </div>
                    <CheckData data={true} name={strings('firstScreen.youGet') + ':'}
                        value={(state.equivalentData.providerName !== '365CASH' ? '~' : '') + state.equivalentData.equivalentData.outAmount + ' ' +
                            (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency)} />
                    <div className={classes.main__wrapper}>
                        <CheckData condition={true} name={strings('secondScreen.rate')} value={(state.equivalentData.providerName !== '365CASH' ? '~' : '') + state.equivalentData.equivalentData.exchangeRate + ' ' +
                            (state.equivalentData.equivalentData.exchangeRatesCurrencySide === 'IN' ? state.inCurrency : (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency))}
                        />
                        <CheckData condition={state.equivalentData.equivalentData.providerFee.in} name={strings('secondScreen.bankFee') + ' ' + getBankFeeString(state)} value={state.equivalentData.equivalentData.providerFee.in + ' ' +
                            (state.equivalentData.equivalentData.exchangeRatesCurrencySide === 'IN' ? state.inCurrency : (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency))}
                        />
                        <CheckData condition={state.equivalentData.equivalentData.providerFee.out} name={strings('secondScreen.networkFee') + ' ' + getNetworkFeeString(state)} value={state.equivalentData.equivalentData.providerFee.out + ' ' +
                            (state.equivalentData.equivalentData.exchangeRatesCurrencySide === 'IN' ? state.inCurrency : (state.outCurrency.length > 5 ? state.outCurrency.slice(4, state.outCurrency.length) : state.outCurrency))}
                        />
                        <CheckData condition={getTrusteeFeeString(state)} name={strings('secondScreen.trusteeFee') + ' ' + getTrusteeFeeString(state)} value={getTrusteeFeeAmount(state)} />
                    </div>
                    <CheckData data={true} name={strings('firstScreen.youGive') + ':'} value={state.equivalentData.equivalentData.inAmount + ' ' + (state.inCurrency.length > 5 ? state.inCurrency.slice(4, state.inCurrency.length) : state.inCurrency)}
                    />
                    <div className={classes.button__wrapper}
                        style={state.exchangeWayType !== 'BUY' ? { paddingBottom: 60 } : null}>
                        <button className={classes.arrow__back} onClick={() => {
                            screenBack(state)
                            analytics().logEvent('click_back_from_paymentScreen')
                        }}>
                            <img src={ArrowBack} alt={'back'} />
                        </button>
                        <div className={classes.check__button}>
                            <button
                                onClick={async () => {
                                    await createOrderButtonHandler(state)
                                    analytics().logEvent('paywayScreen_click_' + state.exchangeWayType.toString().toLowerCase())
                                }}>
                                {strings('firstScreen.' + state.exchangeWayType.toString().toLowerCase()) || strings('firstScreen.createOrder')}
                            </button>
                        </div>
                        {state.isFetching ?
                            <div className={classes.preloader}>
                                <img src={Loader} alt={'Preloader'} height={50} />
                            </div>
                            : null}
                    </div>
                    {state.exchangeWayType === 'BUY' ?
                        <>
                            <div className={classes.check__dash}></div>
                            {/* <div className={classes.check__circle__left}></div>
                            <div className={classes.check__circle__right}></div> */}
                            <div className={classes.download__text}>
                                {strings('secondScreen.downloadText')}
                            </div>
                            <div className={classes.button__app}>
                                <a href={'https://play.google.com/store/apps/details?id=com.trusteewallet'}
                                    target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                        analytics().logEvent('click_google_play')
                                    }}>
                                    <button>
                                        <img src={PlayMarket} alt={'PlayMarket'} />
                                    </button>
                                </a>
                                <a href={'https://apps.apple.com/ua/app/trustee-wallet/id1462924276'}
                                    target="_blank" rel={'noopener noreferrer'} onClick={() => {
                                        analytics().logEvent('click_app_store')
                                    }}>
                                    <button>
                                        <img src={AppStore} alt={'AppStore'} />
                                    </button>
                                </a>
                            </div>
                        </> : null}
                </div>
            </div>
            <ReCAPTCHA
                ref={reCaptchaRef}
                size="invisible"
                sitekey={config.captchaSiteKey}
                style={{ position: 'absolute', top: '20%', }}
            />
        </>
    )

}

export default RenderSecondScreen